module.exports = __webpack_public_path__ + "img/9791158881016.bfaf9908.jpg";